import ModalWrapper from "../ModalWrapper"

const PromptModal = ({ isOpen, setIsOpen, prompt }) => {
  return (
    <ModalWrapper 
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title={prompt?.title}
    >
      <p>{prompt?.body}</p>
      <p>{prompt?.time}</p>
    </ModalWrapper>
  )
}

export default PromptModal